import CardLogin from 'app/components/Layouts/CardLogin';
import { Box, Typography } from '@mui/material';
import { descText, infoText, resendLink } from './EmailSent.sx';
import React from 'react';
import useEmailSent from './useEmailSent';
import BackButton from 'app/components/BackButton';
import CountdownTimer from 'app/components/CountdownTimer';

const EmailSent = () => {
  const { t, handleResend } = useEmailSent();

  return (
    <CardLogin>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Box>
          <Typography sx={infoText}>{t('recovery.linkSent')}</Typography>
          <Typography sx={descText}>{t('recovery.linkSentDesc')}</Typography>
          <CountdownTimer repeat={handleResend} link={true} timerTime={0} />
        </Box>
        <BackButton text={'recovery.back'} />
      </Box>
    </CardLogin>
  );
};

export default EmailSent;
